import { ClipboardModule } from '@angular/cdk/clipboard';
import { ScrollingModule } from "@angular/cdk/scrolling";
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from '@angular/forms';
import { TreeModule } from '@circlon/angular-tree-component';
import { NbButtonModule, NbCalendarModule, NbCalendarRangeModule, NbCardModule, NbCheckboxModule, NbContextMenuModule, NbDatepickerModule, NbDialogModule, NbFormFieldModule, NbIconModule, NbInputModule, NbLayoutModule, NbListModule, NbProgressBarModule, NbRadioModule, NbSelectModule, NbSidebarModule, NbSpinnerModule, NbStepperModule, NbTabsetModule, NbToastrModule, NbTooltipModule, NbWindowModule } from "@nebular/theme";
import { AgGridModule } from 'ag-grid-angular';
import { NgJsonEditorModule } from 'ang-jsoneditor';
import { PagerComponent } from "../@theme/components/pager/pager.component";
import { AdminPipe, ApprovalStatePipe, CapitalizePipe, CommonBlockStatePipe, DocEventPipe, FileEventTypePipe, FilePipe, MediaEventTypePipe, MediaStatusPipe, NumberWithCommasPipe, PluralPipe, ProductPipe, RequestTypePipe, RoundPipe, StatePipe, TimingPipe } from "../@theme/pipes";
import { ContainerControlLabelPipe } from '../@theme/pipes/container-control-label.pipe';
import { EnumLabelPipe } from "../@theme/pipes/enum-label.pipe";
import { FileSizePipe } from "../@theme/pipes/file-size.pipe";
import { HighlightPipe } from '../@theme/pipes/highlight.pipe';
import { NumberUnitPipe } from "../@theme/pipes/number-unit.pipe";
import { PageInfoPipe } from '../@theme/pipes/page-info.pipe';
import { PhonePipe } from "../@theme/pipes/phone.pipe";
import { ResourcePipe } from "../@theme/pipes/resource.pipe";
import { TrimPipe } from '../@theme/pipes/trim.pipe';
import { TruncatePipe } from '../@theme/pipes/truncate.pipe';
import { BackButton } from './components/button/back-button.component';
import { RangePickerComponent } from './components/calander/range-picker.component';
import { ColumnOptionComponent } from "./components/column-option/column-option.component";
import { CsvComponent } from "./components/csv/csv.component";
import { AlertComponent } from './components/dialog/alert/alert.component';
import { DynamicDataGridComponent } from "./components/dynamic-data-grid/dynamic-data-grid.component";
import { BadgeAfterTextColumnComponent } from './components/dynamic-data-grid/renderer/badge-after-text-column.component';
import { BadgeColumnComponent } from './components/dynamic-data-grid/renderer/badge-column.component';
import { CheckboxColumn } from './components/dynamic-data-grid/renderer/checkbox-column.component';
import { ClientDeleteComponent } from "./components/dynamic-data-grid/renderer/client-delete.component";
import { CommonBlockLinkComponent } from './components/dynamic-data-grid/renderer/common-block-link.component';
import { FileInstanceSearchWithLinkComponent } from './components/dynamic-data-grid/renderer/file-instance-search-with-link.component';
import { ProductIdentificationComponent } from './components/dynamic-data-grid/renderer/product-identification-column.component';
import { FlowColumnComponent } from './components/dynamic-data-grid/renderer/flow-column.component';
import { LinkColumnComponent } from './components/dynamic-data-grid/renderer/link.component';
import { MoreColumnComponent } from './components/dynamic-data-grid/renderer/more-column.component';
import { PeriodColumnComponent } from './components/dynamic-data-grid/renderer/period-column.component';
import { RequestApproveComponent } from "./components/dynamic-data-grid/renderer/request-approve.component";
import { RequestConfirmComponent } from "./components/dynamic-data-grid/renderer/request-confirm.component";
import { UserLinkComponent } from "./components/dynamic-data-grid/renderer/user-link.component";
import { DynamicJsonEditorComponent } from './components/editor/json-editor/json-editor.component';
import { OrgChartModule } from './components/org-chart/org-chart.module';
import { PolicyTargetDialogComponent } from './components/policy-target-dialog/policy-target-dialog.component';
import { TagComponent } from './components/tag/tag.component';
import { AdvancedTreeComponent } from './components/tree/tree.component';
import { FileUploadDirective } from "./directives/file-upload.directive";
import { FluidHeightDirective } from './directives/fluid-height.directive';
import { InputNumberDirective } from "./directives/input-number.directive";
import { ResizeBox } from "./directives/resizeBox.directive";
import { RestrictInput } from "./directives/restrict-input.directive";
import { NewProductDefineComponent } from './components/dynamic-data-grid/renderer/new-product-define.component';
import { ClassificationItemStateComponent } from './components/dynamic-data-grid/renderer/classification-item-state-component';
import { ClipboardComponent } from './components/dynamic-data-grid/renderer/clipboard.component';
import { ShowChangesColumnComponent } from './components/dynamic-data-grid/renderer/show-changes-column.component';
import { ProductSearchComponent } from './components/dynamic-data-grid/renderer/product-search.component';
import { ClassificationSearchComponent } from './components/dynamic-data-grid/renderer/classification-search.component';
import { GenerateTokenComponent } from './components/dynamic-data-grid/renderer/generate-token.component';
import { MonthPickerComponent } from './components/calander/month-picker.component';
import { SideFilterComponent } from './components/side-filter/side-filter.component';
import { IconColumnComponent } from './components/dynamic-data-grid/renderer/icon-column.component';
import { ProgressBarColumnComponent } from './components/dynamic-data-grid/renderer/progress-bar-column.component';
import { SideProductSearchComponent } from './components/side-product-search/side-product-search.component';

const NB_MODULES = [
  NbButtonModule,
  NbCardModule,
  NbCheckboxModule,
  NbContextMenuModule,
  NbDatepickerModule,
  NbCalendarModule,
  NbCalendarRangeModule,
  NbDialogModule.forChild(),
  NbIconModule,
  NbInputModule,
  NbLayoutModule,
  NbListModule,
  NbRadioModule,
  NbSelectModule,
  NbSidebarModule,
  NbSpinnerModule,
  NbStepperModule,
  NbFormFieldModule,
  NbTabsetModule,
  NbToastrModule,
  NbTooltipModule,
  NbProgressBarModule,
  TreeModule,
  FormsModule,
  NgJsonEditorModule,
  NbWindowModule.forChild(),
];

const MODULES = [
  CommonModule,
  ScrollingModule,
  ClipboardModule,
  OrgChartModule
]

const COMPONENTS = [
  DynamicDataGridComponent,
  PagerComponent,
  ColumnOptionComponent,
  CsvComponent,
  AlertComponent,
  TagComponent,
  PolicyTargetDialogComponent,
  RangePickerComponent,
  MonthPickerComponent,
  DynamicJsonEditorComponent,
  AdvancedTreeComponent,
  BackButton,
  SideFilterComponent,
  SideProductSearchComponent,
];

const PIPES = [
  CapitalizePipe,
  PluralPipe,
  RoundPipe,
  TimingPipe,
  NumberWithCommasPipe,
  AdminPipe,
  StatePipe,
  TruncatePipe,
  ApprovalStatePipe,
  DocEventPipe,
  RequestTypePipe,
  FileEventTypePipe,
  FilePipe,
  FileSizePipe,
  ContainerControlLabelPipe,
  CommonBlockStatePipe,
  ProductPipe,
  MediaEventTypePipe,
  MediaStatusPipe,
  NumberUnitPipe,
  ResourcePipe,
  PhonePipe,
  EnumLabelPipe,
  TrimPipe,
  HighlightPipe,
  PageInfoPipe
];

const COLUMN_COMPONENTS = [
  RequestConfirmComponent,
  RequestApproveComponent,
  ClientDeleteComponent,
  UserLinkComponent,
  FileInstanceSearchWithLinkComponent,
  CommonBlockLinkComponent,
  ProductIdentificationComponent,
  BadgeColumnComponent,
  BadgeAfterTextColumnComponent,
  MoreColumnComponent,
  FlowColumnComponent,
  LinkColumnComponent,
  GenerateTokenComponent,
  PeriodColumnComponent,
  CheckboxColumn,
  NewProductDefineComponent,
  ClassificationItemStateComponent,
  ClipboardComponent,
  ShowChangesColumnComponent,
  ProductSearchComponent,
  ClassificationSearchComponent,
  IconColumnComponent,
  ProgressBarColumnComponent,
];

const DIRECTIVIES = [
  RestrictInput,
  InputNumberDirective,
  ResizeBox,
  FileUploadDirective,
  FluidHeightDirective
];

/**
 * 공통으로 사용되는 모듈을 설정하는 클래스.
 */
@NgModule({
  declarations: [
    ...COMPONENTS,
    ...COLUMN_COMPONENTS,
    ...PIPES,
    ...DIRECTIVIES
  ],
  imports: [
    ...NB_MODULES, ...MODULES, AgGridModule.withComponents(COLUMN_COMPONENTS)
  ],
  providers: [...PIPES],
  exports: [
    ...MODULES,
    ...COMPONENTS,
    ...COLUMN_COMPONENTS,
    ...PIPES,
    ...DIRECTIVIES,
  ],
  entryComponents: [
    ...COMPONENTS,
    ...COLUMN_COMPONENTS,
  ],
})
export class IscanCommmonModule { }
